import { Wallet, Coins, ArrowLeftRight, Ghost } from "lucide-react";
import { Reveal } from "./Reveal";

const STEPS = [
  {
    Icon: Wallet,
    step: "STEP 01",
    title: "GET A SOLANA WALLET",
    text: "Download Phantom or your favorite Solana wallet. It takes two minutes — less time than carving a pumpkin.",
    color: "text-[#B6FF00]",
    border: "hover:border-[#B6FF00]",
    num: "text-stroke-green",
  },
  {
    Icon: Coins,
    step: "STEP 02",
    title: "LOAD UP SOME SOL",
    text: "Grab some SOL from any exchange and send it to your wallet. Fuel for the summoning ritual.",
    color: "text-[#FF6B00]",
    border: "hover:border-[#FF6B00]",
    num: "text-stroke-purple",
  },
  {
    Icon: ArrowLeftRight,
    step: "STEP 03",
    title: "SWAP FOR $HALLOWIN",
    text: "Head to your favorite Solana DEX, paste the contract address, and swap SOL for $HALLOWIN.",
    color: "text-[#A020F0]",
    border: "hover:border-[#A020F0]",
    num: "text-stroke-green",
  },
  {
    Icon: Ghost,
    step: "STEP 04",
    title: "JOIN THE HALLOWEEN MADNESS",
    text: "You're in. Meme hard, haunt the timeline, and ride the spookiest wave on Solana with the cult.",
    color: "text-[#B6FF00]",
    border: "hover:border-[#B6FF00]",
    num: "text-stroke-purple",
  },
];

export const HowToBuy = () => (
  <section id="how-to-buy" className="relative z-10 py-20 lg:py-32 px-4 sm:px-8" data-testid="how-to-buy-section">
    <div className="max-w-7xl mx-auto">
      <Reveal className="text-center">
        <p className="mono text-xs tracking-[0.35em] text-[#B6FF00] glow-green mb-4">// THE RITUAL</p>
        <h2 className="font-display font-bold uppercase text-3xl sm:text-4xl lg:text-5xl" data-testid="how-to-buy-title">
          <span className="glitch text-[#FF6B00] glow-orange" data-text="HOW TO SUMMON $HALLOWIN">
            HOW TO SUMMON <span className="text-[#B6FF00] glow-green">$HALLOWIN</span>
          </span>
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {STEPS.map(({ Icon, step, title, text, color, border, num }, i) => (
          <Reveal key={step} delay={i * 0.12}>
            <div
              className={`neon-card border border-[#A020F0]/30 ${border} shadow-[0_0_18px_rgba(160,32,240,0.12)] hover:shadow-[0_0_35px_rgba(160,32,240,0.35)] group relative overflow-hidden hover:-translate-y-2 h-full`}
              data-testid={`how-to-buy-step-${i + 1}`}
            >
              <span className={`absolute -top-3 -right-1 font-glitch text-7xl ${num} opacity-40 select-none`}>
                {i + 1}
              </span>
              <Icon className={`w-10 h-10 ${color} group-hover:scale-125 group-hover:-rotate-12 transition-transform duration-300`} />
              <p className="mono text-[10px] tracking-[0.3em] text-purple-300/60 mt-6">{step}</p>
              <h3 className="font-display font-bold text-lg sm:text-xl mt-2 text-white uppercase leading-snug">{title}</h3>
              <p className="text-sm text-purple-200/75 mt-3 leading-relaxed">{text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
